// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Lang
import { nsSimCard } from '@/app/i18n/namespaces';
import CopyableChip from '@/common-utils/components/renders/copyableChip/CopyableChip';

/**
 * @param root0
 * @param root0.nonActivatedSims
 * @returns {JSX} NonActivatedList
 */
function NonActivatedList({ nonActivatedSims }) {
    return (
        <div className='text-center my-4 space-y-2'>
            <div>
                <Entity
                    entity='modal.multiple_activation.partial_activation.text_1'
                    namespace={nsSimCard}
                />
            </div>
            <div className='flex flex-wrap justify-center gap-2 p-2 max-h-64  overflow-auto'>
                {nonActivatedSims.map((simNumber, index) => {
                    return (
                        <CopyableChip key={`${simNumber}-${index}`} text={simNumber} />
                    );
                })}
            </div>
            <div>
                <Entity
                    entity='modal.multiple_activation.partial_activation.text_2'
                    namespace={nsSimCard}
                />
            </div>
        </div>
    );
}

NonActivatedList.propTypes = {
    nonActivatedSims: PropTypes.array
};
export default NonActivatedList;